import '../styles/main.css';
import { Button, Row, Col, Card, Icon, CardTitle } from 'react-materialize';

export default function cart() {

    let renderContent = () => 
        <table className='cart-items-container'>
            <tr>
                <th className='Item' style={{textAlign:'center'}}>Item</th>
                <th className='quantity-price'>Quantity</th>
                <th className='quantity-price'>Price</th>
            </tr>
            {
                Array(2).fill('.').map(item => 
                    <tr>
                        <td className='Item'>
                            <Card
                                className='item'
                                header={<CardTitle image="https://materializecss.com/images/sample-1.jpg" />}
                                horizontal
                                >
                                <div style={{fontWeight: '600'}}>H & M</div>
                                <div style={{fontSize:'smaller', color: '#848791'}}>Round Neck T-Shirt</div>
                            </Card>
                        </td>
                        <td className='quantity-price'>
                            <input type='number' className='quantity' value='0' />
                        </td>
                        <td className='quantity-price'>$ 50</td>
                    </tr>
                    )
            }
            <tr>
                <th style={{textAlign: 'center'}}>Total</th>
                <td></td>
                <td style={{textAlign: 'center'}}>$ 50.99</td>
            </tr>
        </table>
        

    return (
        <div className='cart'>
            <h6 style={{margin: '1rem', fontWeight: 'bolder'}}>SHOPPING CART</h6>
                {renderContent()}
            <Button
                className='checkout-button'
                node="button"
                waves="#306EFF"
            >
                CHECKOUT
            </Button>
        </div>
    )
}